/**
 * Created by Jerker Nord on 2023-10-16.
 */
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {LonerOutroView} from "../../base/LonerOutroView";
import {Loner} from "../../../Loner";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {gsap} from "gsap";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {PixelFont} from "../../../fonts/PixelFont";
import {MAIN_FG_ANIMATION_NAMES} from "../../general/LonerForegroundView";

export class LonerTickTickBoomOutroView extends LonerOutroView {

    private static TTB_OUTRO_SPINS_PLAYED_STYLE: TextStyleOptions = {
        align: "center",
        fontFamily: PixelFont.FAMILY,
        fontSize: "50px",
        fill: "#e0e0e0",
        fontStyle: FontStyle.NORMAL,
        fontWeight: FontWeight.BOLD,
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: Math.PI * 0.5,
        dropShadowBlur: 4,
        dropShadowColor: "#000000",
        dropShadowDistance: 2,
        padding: 20,
        stroke: 2,
        strokeThickness: 2
    };
    private static BET_MULTIPLIED_TEXT_POSITION: PIXI.Point = new PIXI.Point(360, 430);
    private static MAX_WIN_TEXT_POSITION: PIXI.Point = new PIXI.Point(360, 200);

    private _maxWinText: PIXI.Text;

    constructor() {
        super();
        this.name = "LonerTickTickBoomOutroView";
        this.init();
    }

    protected init() {
        super.init();

        this._maxWinText = new PIXI.Text("MAX WIN!", LonerTickTickBoomOutroView.TTB_OUTRO_SPINS_PLAYED_STYLE);
        this._maxWinText.position = LonerTickTickBoomOutroView.MAX_WIN_TEXT_POSITION;
        this._maxWinText.anchor.set(0.5, 0.5);
        this._maxWinText.alpha = 0;
        this._outroContainer.addChild(this._maxWinText);

        this._betMultipliedText = new PIXI.Text("", LonerTickTickBoomOutroView.TTB_OUTRO_SPINS_PLAYED_STYLE);
        this._betMultipliedText.position = LonerTickTickBoomOutroView.BET_MULTIPLIED_TEXT_POSITION;
        this._betMultipliedText.anchor.set(0.5, 0.5);
        this._betMultipliedText.alpha = 0;
        this._outroContainer.addChild(this._betMultipliedText);
        this._outroContainer.addChild(this._countUp);
    }

    public getCountUp(amount: number, countDuration: number = 1.5, isWinBelowStake: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            gsap.to(this._countUp, {duration: 0.4, alpha: 1})
        });

        if (isWinBelowStake) {
            countDuration = 0.001;
        }

        if (!isWinBelowStake){
            tl.add(() => Loner.soundPlayer.startTTBCountUp());
        }
        tl.add(() => {
            this._countUp.startFlicker()
        });
        tl.add(this._countUp.getCountAnimation(0, amount, countDuration));
        if (!isWinBelowStake){
            tl.add(() => Loner.soundPlayer.stopTTBCountUp());
        }
        tl.add(() => {
            Loner.foregroundView.playTTBArmsAnimation(MAIN_FG_ANIMATION_NAMES.TTB_ARMS_END, false);
        }, "-=1.5");
        tl.add(() => {
            Loner.keypadPlugin.setWin(Loner.model.accumulatedRoundWin, true, isWinBelowStake);
        });

        return tl;
    }

    protected getOutroContent(): PIXI.Container {
        return new PIXI.Container();
    }

    public showOutro(callback: Function): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._countUp.position.y = this.getCountUpYPos();
            this._clickCallback = callback;
            this.visible = true;
        });

        tl.add(() => {
            this._betMultipliedText.text = SlotGame.apiPlugin.currency.format(Loner.model.gameData.playedBetValue) + " x " + Loner.model.timesBetWinDraw;
        });
        tl.add([
            //gsap.to(this._background, {duration: 0.6, alpha: 1}),
            gsap.to(this._outroContainer, {duration: 0.6, alpha: 1})
        ]);

        return tl;
    }

    public showBetText(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add([
            gsap.to(this._betMultipliedText, {duration: 0.2, alpha: 0.8})
        ]);
        return tl;
    }

    public showMaxWinText(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add([
            gsap.to(this._maxWinText, {duration: 0.2, alpha: 1})
        ]);
        return tl;
    }

    public hideOutro(isWinBelowStake:boolean):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this._countUp.stopFlicker();
            Loner.allReelView.enableAllViews();
            Loner.allReelView.visible = true;
        });
        tl.add([
            gsap.to(this._outroContainer, {duration : 0.01, alpha : 0}),
            gsap.to(this._button, {duration : 0.01, alpha : 0})
        ]);
        tl.add(() => {
            this._countUp.alpha = 0;
            this._countUp.stopAt(0);
        });
        tl.add(() => {
            this.visible = false;
            this._maxWinText.alpha = 0;
            this._betMultipliedText.alpha = 0;
            Loner.foregroundView.clearAnimationTrack(3);
        });
        return tl;
    }

    protected getOutroContainerPos(): PIXI.Point {
        return new PIXI.Point(0, 0);
    }

    protected getCountUpYPos(): number {
        return 320;
    }
}